<template>
<div class="chapter">
<div class="inner_page">
<p class="prect1"><a id="pV"></a>CONTENTS</p>
<p class="content1"><a href="#/maps.htm#maps"><i>List of Maps and Illustrations</i></a></p>
<p class="content1"><a href="#/note_on_the_text.htm#text"><i>Note on the Text</i></a></p>
<p class="content1"><a href="#/acknowledgements.htm#ack"><i>Acknowledgements</i></a></p>
<p class="content1"><a href="#/introduction.htm#intro"><i>Introduction</i></a></p>
<p class="linespace"></p>
<p class="content-ch"><a href="#/ch1.htm#ch1"><span class="contentblock"> 1</span>Holy War?</a></p>
<p class="content-ch"><a href="#/ch2.htm#ch2"><span class="contentblock"> 2</span>Young Turks</a></p>
<p class="content-ch"><a href="#/ch3.htm#ch3"><span class="contentblock"> 3</span>Little Mehmet</a></p>
<p class="content-ch"><a href="#/ch4.htm#ch4"><span class="contentblock"> 4</span>For Sultan and Caliph</a></p>
<p class="content-ch"><a href="#/ch5.htm#ch5"><span class="contentblock"> 5</span>Sinai Bridgehead</a></p>
<p class="content-ch"><a href="#/ch6.htm#ch6"><span class="contentblock"> 6</span>The Battle of Romani</a></p>
<p class="content-ch"><a href="#/ch7.htm#ch7"><span class="contentblock"> 7</span>The Arab Revolt</a></p>
<p class="content-ch"><a href="#/ch8.htm#ch8"><span class="contentblock"> 8</span>A Crusader, an Unknown Desert and a New Way of War</a></p>
<p class="content-ch"><a href="#/ch9.htm#ch9"><span class="contentblock"> 9</span>The Gates of Palestine</a></p>
<p class="content-ch"><a href="#/ch10.htm#ch10"><span class="contentblock">10</span>Aqaba</a></p>
<p class="content-ch"><a href="#/ch11.htm#ch11"><span class="contentblock">11</span>Bull Loose</a></p>
<p class="content-ch"><a href="#/ch12.htm#ch12"><span class="contentblock">12</span>The Railway War</a></p>
<p class="content-ch"><a href="#/ch13.htm#ch13"><span class="contentblock">13</span>The Third Battle of Gaza</a></p>
<p class="content-ch"><a href="#/ch14.htm#ch14"><span class="contentblock">14</span>Jerusalem</a></p>
<p class="content-ch"><a href="#/ch15.htm#ch15"><span class="contentblock">15</span>The Mountains of Moab</a></p>
<p class="content-ch"><a href="#/ch16.htm#ch16"><span class="contentblock">16</span>Special Operations</a></p>
<p class="content-ch"><a href="#/ch17.htm#ch17"><span class="contentblock">17</span>Armageddon</a></p>
<p class="content1"><a href="#/epilogue.htm#epilogue">Epilogue</a></p>
<p class="linespace"></p>
<p class="content1"><a href="#/endnotes.htm#endnotes"><i>Endnotes</i></a></p>
<p class="content1"><a href="#/timeline.htm#timeline"><i>Timeline</i></a></p>
<p class="content1"><a href="#/bibliography.htm#biblio"><i>Bibliography</i></a></p>
<p class="content1"><a href="#/index.htm#index"><i>Index</i></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?203fd5e2